import { forwardRef, type ButtonHTMLAttributes } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../cn";

const button = cva(
  "inline-flex items-center justify-center gap-2 font-body font-semibold transition-colors " +
    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-saffron focus-visible:ring-offset-2 " +
    "disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      variant: {
        primary: "bg-saffron text-white hover:bg-saffron/90",
        ghost: "bg-transparent text-charcoal hover:bg-sand",
        outline: "border border-charcoal/20 text-charcoal hover:bg-sand",
        link: "text-forest underline underline-offset-2 hover:no-underline",
      },
      size: {
        // 56px primary CTA per RULES + 01-context-and-brand.md.
        lg: "h-14 px-6 text-body-lg rounded-md",
        md: "h-11 px-5 text-body rounded-md",
        sm: "h-9 px-3 text-body-sm rounded",
      },
      fullWidth: {
        true: "w-full",
        false: "",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "lg",
      fullWidth: false,
    },
  },
);

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & VariantProps<typeof button>;

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { className, variant, size, fullWidth, type = "button", ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      className={cn(button({ variant, size, fullWidth }), className)}
      {...rest}
    />
  );
});
